/**
 * Removes hydrogen-weight download fields when a kit/asset has an electrolyser.
 *
 * When an electrolyser is present, hydrogen is generated on site rather than
 * delivered by weight, so the hydrogen-weight columns (`hydrogen_weight_start`,
 * `hydrogen_weight_end`, `hydrogen_weight_consumed`) are not meaningful and are
 * pruned from the available download fields. When there is no electrolyser the
 * field list is returned unchanged.
 *
 * Order of the surviving fields is preserved.
 */

const HYDROGEN_WEIGHT_FIELDS = ["hydrogen_weight_start", "hydrogen_weight_end", "hydrogen_weight_consumed"]

export function pruneHydrogenWeight(fields: string[], hasElectrolyser: boolean): string[] {
  if (!hasElectrolyser) return fields
  return fields.filter((f) => !HYDROGEN_WEIGHT_FIELDS.includes(f))
}
